import { createLoadingReducer } from './utils';

export default createLoadingReducer('MAILCHIMP_SETTINGS');
